var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content main-small-routine" }, [
    _vm._m(0),
    _c("div", { staticClass: "container content-body" }, [
      _c(
        "div",
        { staticClass: "content-item-list" },
        _vm._l(_vm.content, function(val, key) {
          return _c("div", { key: key, class: ["content-item"] }, [
            _c("div", { staticClass: "content-item-info" }, [
              _c("img", { attrs: { src: val.icon, alt: "" } })
            ]),
            _c("span", [_vm._v(_vm._s(val.text))])
          ])
        }),
        0
      )
    ]),
    _c("div", { staticClass: "content-marketing" }, [
      _c("div", { staticClass: "container content-marketing-body" }, [
        _c("h3", { staticClass: "services-title" }, [
          _vm._v("小程序  企业营销新利器")
        ]),
        _c(
          "div",
          { staticClass: "content-marketing-list" },
          _vm._l(_vm.marketing, function(val, key) {
            return _c(
              "div",
              { key: key, staticClass: "content-marketing-item" },
              [
                _c("div", { staticClass: "content-marketing-icon" }, [
                  _c("img", { attrs: { src: val.icon, alt: "" } })
                ]),
                _c("div", { staticClass: "marketing-line" }),
                _c("span", { staticClass: "content-marketing-text" }, [
                  _vm._v(_vm._s(val.title))
                ])
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content-title" }, [
      _c("h3", { staticClass: "services-title" }, [_vm._v("小程序开发")]),
      _c("p", { staticClass: "container-sub-title" }, [
        _vm._v("共享微信全生态 触手可及微信9亿用户")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84172a5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84172a5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/small-routine/Content.vue
// module id = 2l58
// module chunks = 18